<app-loader [parentData]="false" class="loader-block" [hidden]="!showLoader"></app-loader>
<div>
   <app-header></app-header>
   <div class="main-content">
        <router-outlet></router-outlet>
   </div>
</div>



